import React from 'react'
import Responsive, { MediaQueryProps } from 'react-responsive'
import { useMediaQuery } from '@material-ui/core'
import { theme } from '../../theme'

function Mobile(props: MediaQueryProps) {
  return <Responsive {...props} maxWidth={theme.breakpoints.mobile} />
}

export function useIsMobile(): boolean {
  const matches = useMediaQuery(`(max-width: ${theme.breakpoints.mobile})`)

  return matches
}

export default Mobile
